import { TrendingUp, Users, Clock } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const ROISnapshotSection = () => {
  const metrics = [
    {
      icon: TrendingUp,
      title: "Missed-call rescue",
      value: "+18–35% more bookings",
      description: "Convert abandoned calls into revenue"
    },
    {
      icon: Users,
      title: "Reactivation of aged leads",
      value: "8–15% revive rate",
      description: "Bring cold prospects back to life"
    },
    {
      icon: Clock,
      title: "Labor savings",
      value: "20–40 hrs/month per rep",
      description: "Automate follow-ups, reminders, scheduling"
    }
  ];

  return (
    <section className="py-16 space-y-8">
      <div className="text-center space-y-4">
        <h2 className="text-3xl md:text-4xl font-bold text-foreground">
          ROI Snapshot
        </h2>
        <p className="text-muted-foreground text-base max-w-2xl mx-auto">
          Real impact on your bottom line from day one
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {metrics.map((metric, index) => (
          <Card key={index} className="border-border hover:shadow-lg transition-shadow">
            <CardContent className="p-6 space-y-4">
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                <metric.icon className="w-6 h-6 text-primary" />
              </div>
              <div>
                <h3 className="font-semibold text-foreground mb-1">{metric.title}</h3>
                <p className="text-2xl font-bold text-primary mb-2">{metric.value}</p>
                <p className="text-sm text-muted-foreground">{metric.description}</p>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
};

export default ROISnapshotSection;
